import React, { useEffect, useState } from "react";
import logopng from "../../../assets/logo-willalwaysloveu.png";
import { useNavigate, useLocation } from "react-router-dom";
import { useUserContext } from "../../../context/MemorialContext";
import { updateHasPaid } from "./utils";
import "../about/about.css";

function Success() {
  const navigate = useNavigate();
  const location = useLocation();
  const [purchaseType, setPurchaseType] = useState(null);
  const [planId, setPlanId] = useState(null);
  const [continuing, setContinuing] = useState(false);

  const { user, setUser, fetchUser } = useUserContext();

  const isFirstPlanFlow =
    purchaseType === "FIRST_PLAN_PURCHASE" ||
    purchaseType === null ||
    (purchaseType !== "PLAN_UPGRADE" && purchaseType !== "FRAME_ONLY");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get("purchaseType");
    const plan = searchParams.get("plan");

    if (type) {
      setPurchaseType(type);
    }

    if (!type && searchParams.get("package")) {
      setPurchaseType("FIRST_PLAN_PURCHASE");
    }

    if (plan !== null && plan !== "") {
      setPlanId(plan);
      localStorage.setItem("package", plan);
    }
  }, [location.search]);

  useEffect(() => {
    if (user && isFirstPlanFlow) {
      updateHasPaid(user, true, setUser).catch(() => {});
    }
    // setUser is stable enough; including it can retrigger the paid-flag update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isFirstPlanFlow]);

  const handleContinue = async () => {
    if (purchaseType === "PLAN_UPGRADE" || purchaseType === "FRAME_ONLY") {
      navigate("/mymemo");
      return;
    }

    setContinuing(true);
    try {
      if (user) {
        await updateHasPaid(user, true, setUser);
        await fetchUser();
      }
      sessionStorage.setItem("memorialWizardAfterPayment", "1");
      navigate("/creatememorial", {
        state: { fromPayment: true, initialStep: "privacy" },
      });
    } catch (error) {
      console.error("Error continuing after payment:", error);
      alert(
        "We could not confirm your plan. Please try again or contact support.",
      );
    } finally {
      setContinuing(false);
    }
  };

  const title =
    planId === "0" ? "Plan selected" : "Payment successful";

  const description = isFirstPlanFlow
    ? "Your plan is active. Next, choose privacy settings, then pick a theme to publish your memorial. It will appear in My Memorials once you finish."
    : "At willalwaysloveu, we provide a shared, easily-accessible virtual space where family members and friends can pay homage to a special life while helping each other heal by sharing their feelings, warm memories, and words of support.";

  return (
    <div className="aboutpage">
      <div className="ab-top">
        <img
          src={logopng}
          className="payment-status-logo"
          alt="WillAlwaysLoveU — online memorial website logo"
        />
        <div className="content1">
          <p className="tp">{title}</p>
          <p className="btm">{description}</p>

          <div className="addressWrapper">
            <button
              className="memobtn"
              onClick={handleContinue}
              disabled={continuing}
            >
              {continuing
                ? "Please wait..."
                : purchaseType === "PLAN_UPGRADE"
                  ? "View my memorial"
                  : purchaseType === "FRAME_ONLY"
                    ? "Go to my memorials"
                    : "Continue setup"}
            </button>
          </div>
        </div>
      </div>

      <div className="triagnle"></div>
      <div className="ab-bottom"></div>
    </div>
  );
}

export default Success;
